var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 13.3337H2.66732C1.93094 13.3337 1.33398 12.7367 1.33398 12.0003V4.00033C1.33398 3.26395 1.93094 2.66699 2.66732 2.66699H13.334C14.0704 2.66699 14.6673 3.26395 14.6673 4.00033V12.0003C14.6673 12.7367 14.0704 13.3337 13.334 13.3337ZM2.66732 8.00033V12.0003H13.334V8.00033H2.66732ZM2.66732 4.00033V5.33366H13.334V4.00033H2.66732ZM8.66732 10.667H4.00065V9.33366H8.66732V10.667Z",
    fill: "#929DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.d5d257dcf3575320da8eaf6c9270285b.svg";
export { ForwardRef as ReactComponent };